import { render, staticRenderFns } from "./upload-new.vue?vue&type=template&id=5d134983&scoped=true&"
import script from "./upload-new.vue?vue&type=script&lang=js&"
export * from "./upload-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d134983",
  null
  
)

export default component.exports